export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('Navigation', () => ({
        stateKey: {
          key: '',
          value: null,
        },
        changeStateKey(key) {
          this.stateKey = key;
        },
        redirectToURL() {
          if (this.stateKey) {
            window.location.href = `https://orders.bizee.com/virtual-address?serviceState=${this.stateKey}`;
          }
        },
        changeStateToURL(state) {
          return state.value.toLowerCase().replace(/\s/g, '-');
        },
        redirectToStatePage(state) {
          const modifyState = this.changeStateToURL(state);

          window.location.href = `https://bizee.com/${modifyState}-virtual-mailbox`;
        },
      }));
    });
  },
};
